// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import 'firebase/storage';
import firebase from 'firebase/app';

//COMPONENT

class ImageSection extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            previewURL: '',
        };

        this.loadImage = this.loadImage.bind(this);
    }

    componentDidMount(){
        this._isMounted = true;
    }

    componentDidUpdate(prevProps) {
        if (this.state.previewURL == '' ||  this.state.previewURL == undefined || (this.props.imageName != prevProps.imageName)) {
            this.loadImage();
        }
    }

    loadImage(){
        if (this.props.imageName != undefined) {
            let imageName = this.props.imageName;
            firebase.storage().ref().child(this.props.storageLocation +  '/' + imageName).getDownloadURL().then(function(url) {
                this._isMounted && this.setState({previewURL: url});
            }.bind(this)).catch(function(error) {
                console.log(error);
            });
        }
    }

    render() {
        return (
            <div className='equipment-details-wrapper vision-card'>
                <div className='image-section-wrapper'>
                    <div className='image-section-container' style={{width: this.props.width, height: this.props.height}}>
                        <img className='image-section-image noselect' src={this.state.previewURL == '' ? require('../../images/empty-preview.png') : this.state.previewURL}/>
                    </div>
                </div>
            </div>
        );
    }
}

ImageSection.propTypes = {
    imageName: PropTypes.string,
    storageLocation: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

const hoc = withRouter(ImageSection);

// EXPORT COMPONENT
export { hoc as ImageSection };


// WEBPACK FOOTER //
// ./src/components/containers/ImageSection.js